webpackJsonp([35],{

/***/ 1147:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Login = __webpack_require__(2212);

var _Login2 = _interopRequireDefault(_Login);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Login2.default;

/***/ }),

/***/ 1228:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AuthLayoutContainer = __webpack_require__(1229);

var _AuthLayoutContainer2 = _interopRequireDefault(_AuthLayoutContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AuthLayoutContainer2.default;

/***/ }),

/***/ 1229:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AuthLayoutContainer = undefined;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(10);

var _classnames2 = _interopRequireDefault(_classnames);

var _AuthLayoutContainer = __webpack_require__(1230);

var _AuthLayoutContainer2 = _interopRequireDefault(_AuthLayoutContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var AuthLayoutContainer = function AuthLayoutContainer(_ref) {
    var className = _ref.className,
        children = _ref.children,
        other = _objectWithoutProperties(_ref, ['className', 'children']);

    return _react2.default.createElement(
        'div',
        Object.assign({
            className: (0, _classnames2.default)(_AuthLayoutContainer2.default.box, className)
        }, other),
        children
    );
};

exports.AuthLayoutContainer = AuthLayoutContainer;
AuthLayoutContainer.propTypes = {
    className: _propTypes2.default.string,
    children: _propTypes2.default.node
};

exports.default = AuthLayoutContainer;

/***/ }),

/***/ 1230:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1231);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(390)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/less-loader/dist/cjs.js!./AuthLayoutContainer.css", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/less-loader/dist/cjs.js!./AuthLayoutContainer.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1231:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(389)(undefined);
// imports


// module
exports.push([module.i, "._30WzcOrPBaNwG8nUHM-8RW {\n  max-width: 519px;\n  background-color: #FFFFFF;\n  border: 1px solid #E0E0E0;\n  padding: 40px;\n  position: relative;\n}\n@media (max-width: 540px) {\n  ._30WzcOrPBaNwG8nUHM-8RW {\n    width: 100%;\n    padding: 24px 16px;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"box": "_30WzcOrPBaNwG8nUHM-8RW"
};

/***/ }),

/***/ 1712:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prepareError = function prepareError(error) {
    if (!error) {
        return null;
    }

    if (error && error.toLowerCase().indexOf('we are unable to redirect your account') !== -1) {
        return _react2.default.createElement(
            'span',
            null,
            error,
            typeof Intercom !== 'undefined' ? _react2.default.createElement(
                'span',
                null,
                ' Please ',
                _react2.default.createElement(
                    'a',
                    {
                        href: '#intercom-container',
                        onClick: function onClick(e) {
                            e.preventDefault();
                            Intercom('show');
                        }
                    },
                    'contact our support team'
                ),
                ' for more assistance.'
            ) : ''
        );
    }
    return error;
}; /* global Intercom */
exports.default = prepareError;

/***/ }),

/***/ 2212:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _reactRouterDom = __webpack_require__(20);

var _queryString = __webpack_require__(31);

var _queryString2 = _interopRequireDefault(_queryString);

var _Login = __webpack_require__(2213);

var _Login2 = _interopRequireDefault(_Login);

var _auth = __webpack_require__(28);

var _LoginForm = __webpack_require__(2215);

var _LoginForm2 = _interopRequireDefault(_LoginForm);

var _SecondaryButton = __webpack_require__(120);

var _SecondaryButton2 = _interopRequireDefault(_SecondaryButton);

var _Button = __webpack_require__(53);

var _Button2 = _interopRequireDefault(_Button);

var _siteModes = __webpack_require__(32);

var _siteModes2 = _interopRequireDefault(_siteModes);

var _AuthLayoutContainer = __webpack_require__(1228);

var _AuthLayoutContainer2 = _interopRequireDefault(_AuthLayoutContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Login = function Login(_ref) {
  var login = _ref.login,
      siteMode = _ref.siteMode,
      companyName = _ref.companyName,
      companyDomain = _ref.companyDomain,
      LTIURL = _ref.LTIURL,
      search = _ref.location.search;

  var params = _queryString2.default.parse(search);
  var normal = 'normal' in params;
  var next = params.next ? '&next=' + params.next : '';

  var notCurrentStudentButton = function notCurrentStudentButton() {
    var skipDomains = ['berry', 'ccu', 'losrios'];
    if (skipDomains.includes(companyDomain)) {
      return null;
    }
    return _react2.default.createElement(
      'div',
      { className: _Login2.default.footer },
      _react2.default.createElement(
        'div',
        { className: _Login2.default.notStudent },
        'NOT A CURRENT STUDENT?'
      ),
      _react2.default.createElement(
        _SecondaryButton2.default,
        { to: '/login?normal' + next },
        'LOGIN HERE'
      )
    );
  };

  if (LTIURL && !normal) {
    return _react2.default.createElement(
      _react2.default.Fragment,
      null,
      _react2.default.createElement(
        _AuthLayoutContainer2.default,
        { className: _Login2.default.lticontainer },
        _react2.default.createElement(
          'h1',
          null,
          companyName + ' Student Login'
        ),
        _react2.default.createElement(
          'p',
          null,
          'You\u2019ll need to enter your school login information to access ' + (siteMode === _siteModes2.default.EDUCATION ? 'PathwayU' : 'jobZology'),
          '.'
        ),
        _react2.default.createElement(
          _Button2.default,
          { href: LTIURL },
          'Login'
        )
      ),
      notCurrentStudentButton()
    );
  }

  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(
      _AuthLayoutContainer2.default,
      null,
      _react2.default.createElement(_LoginForm2.default, {
        onSubmit: function onSubmit(_ref2) {
          var userName = _ref2.userName,
              password = _ref2.password;
          return new Promise(function (resolve, reject) {
            return login({ userName: userName, password: password, reject: reject, resolve: resolve });
          });
        }
      })
    ),
    companyDomain && companyDomain !== 'login' ? _react2.default.createElement(
      'div',
      { className: _Login2.default.join },
      _react2.default.createElement(
        'div',
        { className: _Login2.default.dontHaveAccount },
        'Don\u2019t have an account yet?'
      ),
      _react2.default.createElement(
        _reactRouterDom.Link,
        { to: '/signup' },
        _react2.default.createElement(
          _SecondaryButton2.default,
          null,
          'join now'
        )
      )
    ) : null
  );
};

Login.propTypes = {
  login: _propTypes2.default.func,
  LTIURL: _propTypes2.default.string,
  location: _propTypes2.default.object,
  siteMode: _propTypes2.default.number,
  companyName: _propTypes2.default.string,
  companyDomain: _propTypes2.default.string
};

Login.displayName = 'Login';

exports.default = (0, _reactRedux.connect)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    LTIURL: theme.LTIURL,
    siteMode: theme.siteMode,
    companyDomain: theme.companyDomain,
    companyName: theme.companyName
  };
}, {
  login: _auth.loginAction
})(Login);

/***/ }),

/***/ 2213:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2214);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(390)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../node_modules/less-loader/dist/cjs.js!./Login.css", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../../node_modules/less-loader/dist/cjs.js!./Login.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2214:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(389)(undefined);
// imports


// module
exports.push([module.i, "._2zj0jFDaBjW_5VSRXC28A1 {\n  margin-bottom: 16px;\n  text-align: center;\n}\n._2zj0jFDaBjW_5VSRXC28A1 ._3zBnqSqjTHuhPr00PfnSzu {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 22px;\n  color: #727272;\n  margin: 24px 0 16px 0;\n  text-transform: uppercase;\n}\n._1tc4RBRAPDuTqEL5IZPSaf {\n  text-align: center;\n}\n._1tc4RBRAPDuTqEL5IZPSaf p {\n  margin: 0 0 24px 0;\n}\n._10dYgHrpsTHolJ9q939zCv {\n  margin: 24px 0 0 0;\n  text-align: center;\n}\n._ggH5xCNpggeMvIue7T8 {\n  color: #727272;\n  font-size: 18px;\n  margin: 0 0 16px 0;\n  font-weight: 500;\n  line-height: 22px;\n}\n", ""]);

// exports
exports.locals = {
	"join": "_2zj0jFDaBjW_5VSRXC28A1",
	"dontHaveAccount": "_3zBnqSqjTHuhPr00PfnSzu",
	"lticontainer": "_1tc4RBRAPDuTqEL5IZPSaf",
	"footer": "_10dYgHrpsTHolJ9q939zCv",
	"notStudent": "_ggH5xCNpggeMvIue7T8"
};

/***/ }),

/***/ 2215:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LoginForm = __webpack_require__(2216);

var _LoginForm2 = _interopRequireDefault(_LoginForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _LoginForm2.default;

/***/ }),

/***/ 2216:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reduxForm = __webpack_require__(16);

var _reactRouterDom = __webpack_require__(20);

var _compose = __webpack_require__(15);

var _compose2 = _interopRequireDefault(_compose);

var _reactRedux = __webpack_require__(3);

var _queryString = __webpack_require__(31);

var _queryString2 = _interopRequireDefault(_queryString);

var _classnames = __webpack_require__(10);

var _classnames2 = _interopRequireDefault(_classnames);

var _Input = __webpack_require__(45);

var _Input2 = _interopRequireDefault(_Input);

var _PasswordInput = __webpack_require__(418);

var _PasswordInput2 = _interopRequireDefault(_PasswordInput);

var _FormError = __webpack_require__(71);

var _FormError2 = _interopRequireDefault(_FormError);

var _Button = __webpack_require__(53);

var _Button2 = _interopRequireDefault(_Button);

var _FlatButton = __webpack_require__(391);

var _FlatButton2 = _interopRequireDefault(_FlatButton);

var _issueWithRedirectError = __webpack_require__(1712);

var _issueWithRedirectError2 = _interopRequireDefault(_issueWithRedirectError);

var _LoginForm = __webpack_require__(2217);

var _LoginForm2 = _interopRequireDefault(_LoginForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LoginForm = function LoginForm(_ref) {
    var handleSubmit = _ref.handleSubmit,
        pristine = _ref.pristine,
        submitting = _ref.submitting,
        error = _ref.error,
        autoFillEmail = _ref.autoFillEmail;
    return _react2.default.createElement(
        'div',
        {
            className: _LoginForm2.default.container
        },
        _react2.default.createElement(
            'form',
            { onSubmit: handleSubmit },
            _react2.default.createElement(
                'h1',
                null,
                'Login'
            ),
            _react2.default.createElement(
                'p',
                null,
                'Enter your information below.'
            ),
            _react2.default.createElement(_FormError2.default, {
                style: { textAlign: 'center' },
                error: (0, _issueWithRedirectError2.default)(error)
            }),
            _react2.default.createElement(_reduxForm.Field, {
                name: 'userName',
                label: 'Email',
                component: _Input2.default,
                className: (0, _classnames2.default)(_LoginForm2.default.userName, _defineProperty({}, _LoginForm2.default.disabled, !!autoFillEmail)),
                disabled: !!autoFillEmail
            }),
            _react2.default.createElement(_reduxForm.Field, {
                name: 'password',
                label: 'Password',
                component: _PasswordInput2.default
            }),
            _react2.default.createElement(
                _FlatButton2.default,
                {
                    to: '/forget-password' + (autoFillEmail ? '?email=' + encodeURIComponent(autoFillEmail) : ''),
                    className: _LoginForm2.default.forgetPasswordLink
                },
                'Forgot Password?'
            ),
            _react2.default.createElement(
                'div',
                { style: { textAlign: 'center' } },
                _react2.default.createElement(
                    _Button2.default,
                    {
                        type: 'submit',
                        disabled: pristine,
                        loading: submitting
                    },
                    'LOGIN'
                )
            )
        )
    );
};

LoginForm.propTypes = {
    handleSubmit: _propTypes2.default.func,
    submitting: _propTypes2.default.bool,
    pristine: _propTypes2.default.bool,
    error: _propTypes2.default.string,
    autoFillEmail: _propTypes2.default.string
};

exports.default = (0, _compose2.default)(_reactRouterDom.withRouter, (0, _reactRedux.connect)(function (state, _ref2) {
    var location = _ref2.location;

    var autoFillEmail = '';
    var query = _queryString2.default.parse(location.search);
    if (query.email) {
        autoFillEmail = query.email;
    }
    return {
        initialValues: {
            password: '',
            userName: autoFillEmail
        },
        autoFillEmail: autoFillEmail
    };
}), (0, _reduxForm.reduxForm)({
    form: 'login'
}))(LoginForm);

/***/ }),

/***/ 2217:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2218);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(390)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/less-loader/dist/cjs.js!./LoginForm.css", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/less-loader/dist/cjs.js!./LoginForm.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2218:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(389)(undefined);
// imports


// module
exports.push([module.i, ".DvIaI1KKprmgPHG0INgMy {\n  display: block;\n  text-align: left;\n  margin-bottom: 32px;\n}\n.DvIaI1KKprmgPHG0INgMy button {\n  text-transform: uppercase;\n}\n.ahUb-eSwnyz7ne4q-85mB {\n  margin-bottom: 32px;\n}\n@media (max-width: 540px) {\n  .ahUb-eSwnyz7ne4q-85mB {\n    margin-bottom: 16px;\n  }\n}\n.ahUb-eSwnyz7ne4q-85mB.vKaaiPw6mXUcYJmcsAeGO {\n  opacity: 0.6;\n  pointer-events: none;\n}\n", ""]);

// exports
exports.locals = {
	"forgetPasswordLink": "DvIaI1KKprmgPHG0INgMy",
	"userName": "ahUb-eSwnyz7ne4q-85mB",
	"disabled": "vKaaiPw6mXUcYJmcsAeGO"
};

/***/ })

});


// WEBPACK FOOTER //
// js/35.6d29406d.chunk.js